import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import "./addUserByAdmin.scss";
import InputField from "../../jsx/components/fields/inputField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import JoinAsField from "../../jsx/components/fields/joinAsField";
import {
  confirmPasswordValidation,
  emailValidation,

  noSpaceOnChange,
  passwordValidation,
  phoneOnChange,
  phoneValidation,

  firstNameValidation
} from '../../functions/validations'
import { useNavigate } from 'react-router-dom';
import { signUp } from '../../service/api/user/signUp';
import PhonenumberField from "../../jsx/components/fields/phoneFields"
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { btnAddUser } from "../../dataBaseFile/alert";
import { lblEmail, lblFirstName, lblLastName, txtMobileNumber, txtSignUpAs, validEmail_OR_MobileNumberText, validMobileNumberText } from "../../dataBaseFile/label";
import { errEmptyEmailOrPhone, validEmailText, validFirstName } from "../../dataBaseFile/error";
import SelectInputState from "../../jsx/components/fields/selectInputState";
import { getRegistereedCompaniesApi } from "../../service/api/user/getRegisteredCompanies";
import SelectStateCompanies from "../../jsx/components/fields/selectStateCompanies";
import { apiGetRegisteredCompanies } from "../../service/api/companies/getRegisteredCompanies";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { sendCompanyInvitationApi } from "../../service/api/companies/sendCompanyInvitation";
const AddUserByAdmin = ({ addUserTrigger, handleCloseAddUser }) => {
  const { role } = useSelector((state) => state.user);
  const { permissionArr, impersonateFlag, companyId } = useSelector((state) => state.user);
  const permissionArray = permissionArr[0] || []
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [firstName, setFirstName] = useState('')
  const [isFirstNameError, setIsFirstNameError] = useState(false)
  const [isLastNameError, setIsLastNameError] = useState(false)
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [isEmailError, setIsEmailError] = useState(false)
  const [phonenumber, setPhonenumber] = useState('')
  const [isPhoneError, setIsPhoneError] = useState(false)
  const [countryCode, setCountryCode] = useState(1)
  const [roleUser, setRoleUser] = useState('1')
  const [loaderActive, setLoaderActive] = useState(false)
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [resMessage, setResMessage] = useState("");
  const [companiesList, setCompaniesList] = useState([])
  const [companyIdSuper, setCompanyIdSuper] = useState('')

  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [sortByValue, setSortByValue] = useState("DESC");
  const [columnName, setColumnName] = useState("created_date_dtm");
  const [searchValue, setSearchValue] = useState("");

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState(1);
  const [isPhone, setIsPhone] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");

  const handleRole = (e) => {
    setRoleUser(e.target.value)
  }
  const handleFirstName = (e) => {
    setIsFirstNameError(false)
    setFirstName(e.target.value)
  }
  const handleLastName = (e) => {
    setIsLastNameError(false)
    setLastName(e.target.value)
  }

  const handleEmail = (e) => {
    setIsEmailError(false)
    setIsPhoneError(false)
    noSpaceOnChange(e.target.value) && setEmail(e.target.value)
  }

  const handlePhonenumber = (e) => {
    setIsPhoneError(false)
    setIsEmailError(false)
    phoneOnChange(e.target.value) && setPhonenumber(e.target.value)
  }

  const handleCountryCode = (e, v) => {
    // setCountryCode(v.country_id_ids)
    setCountryCode(e)
  }


  function afterSuccessCall() {
    setLoaderActive(false)
    // openNotification("success",'topRight',"User Added")      
    // openNotification("success",'topRight',"User Added")    
    setFirstName('')
    setLastName('')
    setRoleUser('2')
    setPhonenumber('')
    setCountryCode(1)
    setEmail('')
  }

  const handleRegisterUserBySuperAdmin = () => {


    // let details = {
    //   first_name_chr: firstName,
    //   last_name_chr: lastName,
    //   role_id_list: [parseInt(roleUser)],
    //   phone_code_id_int: parseInt(countryCode) || 1,
    //   phone_number_int: parseInt(phonenumber) || 0,
    //   email_chr: email,
    //   password: "Chilll@123456",
    //   confirm_password: "Chilll@123456",
    //   creator_user_id_ids: localStorage.getItem("user_id"),
    //   company_id_ids: companyIdSuper ? companyIdSuper : "",
    //   // creator_role_id_int: parseInt(role)
    // }

    if (isPhone) {
      let details = {
        first_name_chr: firstName,
        last_name_chr: lastName,
        role_id_list: [parseInt(roleUser)],
        phone_code_id_int: parseInt(codeValue) || 1,
        phone_number_int: parseInt(emailPhoneValue) || 0,
        email_chr: '',
        password: "Chilll@123456",
        confirm_password: "Chilll@123456",
        creator_user_id_ids: localStorage.getItem("user_id"),
        company_id_ids: companyIdSuper ? companyIdSuper : "",
        // creator_role_id_int: parseInt(role)
      }

      dispatch(signUp(details, (res) => {
        setToasterType("success")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        afterSuccessCall()
        handleCloseAddUser()
      }, (res) => {
        setToasterType("error")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        setLoaderActive(false)
      }))

    } else {
      let details = {
        first_name_chr: firstName,
        last_name_chr: lastName,
        role_id_list: [parseInt(roleUser)],
        phone_code_id_int: parseInt(countryCode) || 1,
        phone_number_int: parseInt(emailPhoneValue) || 0,
        email_chr: emailPhoneValue,
        password: "Chilll@123456",
        confirm_password: "Chilll@123456",
        creator_user_id_ids: localStorage.getItem("user_id"),
        company_id_ids: companyIdSuper ? companyIdSuper : "",
        // creator_role_id_int: parseInt(role)
      }
      dispatch(signUp(details, (res) => {
        setToasterType("success")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        afterSuccessCall()
        handleCloseAddUser()
      }, (res) => {
        setToasterType("error")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        setLoaderActive(false)
      }))
    }
  }

  const handleAddTeamMemberByAdmin = () => {
    // const data = new FormData();
    // data.append("company_id_ids", companyId);
    // data.append("email_chr", email);
    // data.append("phone_code_id_int", countryCode || 0);
    // data.append("phone_number_int", phonenumber || 0);
    // data.append("role_id_ids", parseInt(roleUser));

    if (isPhone) {
      const data = new FormData();
      data.append("company_id_ids", companyId);
      data.append("email_chr", '');
      data.append("phone_code_id_int", codeValue || 0);
      data.append("phone_number_int", emailPhoneValue || 1);
      data.append("role_id_ids", parseInt(roleUser));

      dispatch(sendCompanyInvitationApi(data, (res) => {
        setToasterType("success")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        afterSuccessCall()
        handleCloseAddUser()

      }, (res) => {
        setToasterType("error")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        setLoaderActive(false)
      }))

    } else {
      const data = new FormData();
      data.append("company_id_ids", companyId);
      data.append("email_chr", emailPhoneValue);
      // data.append("phone_code_id_int", codeValue || 0);
      // data.append("phone_number_int", emailPhoneValue || 0);
      data.append("role_id_ids", parseInt(roleUser));
      
      dispatch(sendCompanyInvitationApi(data, (res) => {
        setToasterType("success")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        afterSuccessCall()
        handleCloseAddUser()

      }, (res) => {
        setToasterType("error")
        setResMessage(res.data.message);
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
        setLoaderActive(false)
      }))
    }
  }


  const handleSubmitOld = () => {

    if (emailValidation(email) || phoneValidation(phonenumber)) {

      if (permissionArray.includes("ASSIGN COMPANY")) {
        if (firstNameValidation(firstName)) {
          setLoaderActive(true)
          handleRegisterUserBySuperAdmin();

        } else {
          // setIsFirstNameError(true)
          if (!firstNameValidation(firstName)) {
            setIsFirstNameError(true)
          }
          // if (!firstNameValidation(lastName)) {
          //   setIsLastNameError(true)
          // }
        }
      } else {
        setLoaderActive(true)
        handleAddTeamMemberByAdmin();
      }

    } else {
      if (!emailValidation(email)) {
        setIsEmailError(true)
      }
      if (!phoneValidation(phonenumber)) {
        setIsPhoneError(true)
      }
    }
  }

  const handleSubmit = () => {

    if (permissionArray.includes("ASSIGN COMPANY")) {
      if (!firstNameValidation(firstName)) {
        setIsFirstNameError(true)
      }

      if (!isPhone) {
        if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          if (emailPhoneValue === "") {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(errEmptyEmailOrPhone);
          } else if (!phoneValidation(emailPhoneValue)) {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(validEmail_OR_MobileNumberText);
          }
        }
      } else {
        if (!phoneValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          if (emailPhoneValue === "") {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(errEmptyEmailOrPhone);
          } else if (!emailValidation(emailPhoneValue)) {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(validEmail_OR_MobileNumberText);
          }
        }
      }

      if (firstNameValidation(firstName) && (!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue))) {
        setLoaderActive(true)
        handleRegisterUserBySuperAdmin();
      }
    } else {
      if (!isPhone) {
        if (!emailValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          if (emailPhoneValue === "") {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(errEmptyEmailOrPhone);
          } else if (!phoneValidation(emailPhoneValue)) {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(validEmail_OR_MobileNumberText);
          }
        }
      } else {
        if (!phoneValidation(emailPhoneValue)) {
          setIsEmailPhoneVal(true);
          if (emailPhoneValue === "") {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(errEmptyEmailOrPhone);
          } else if (!emailValidation(emailPhoneValue)) {
            setIsEmailPhoneVal(true);
            setLoginErrorMsg(validEmail_OR_MobileNumberText);
          }
        }
      }

      if ((!isPhone ? emailValidation(emailPhoneValue) : phoneValidation(emailPhoneValue))) {
        setLoaderActive(true)
        handleAddTeamMemberByAdmin();
      }
    }
  }

  function handleFirstNameBlurCheck() {
    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true)
    }
  }
  function handleLastNameBlurCheck() {
    if (lastName.trim().length > 0) {
      if (!firstNameValidation(lastName)) {
        setIsLastNameError(true)
      }
    }



  }
  function handleEmailBlurCheck() {
    if (!emailValidation(email)) {
      setIsEmailError(true)
    }
  }

  function handlePhonenumberBlurCheck() {
    if (!phoneValidation(phonenumber)) {
      setIsPhoneError(true)
    }
  }

  useEffect(() => {

    // let details = {}
    // dispatch(getRegistereedCompaniesApi(details, (res) => {
    //   setCompaniesList(res.data.data)

    // }, (err) => { })) 

    if (permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) {
      const getComapnies = new FormData();
      getComapnies.append("user_id_ids", localStorage.getItem("user_id"));
      getComapnies.append("pagination_flag", 1);
      getComapnies.append("page_index", page);
      getComapnies.append("page_size", pageSize);
      getComapnies.append("sorting_order", sortByValue);
      getComapnies.append("sorting_column_name", columnName);
      getComapnies.append("search_area", searchValue);
      dispatch(
        apiGetRegisteredCompanies(getComapnies, (res) => {
          // setElements(res.data.data);
          setCompaniesList(res.data.data)
        }, (err) => { })
      );
    }
  }, [])


  function handleCompaniesSelectValue(e) {
    setCompanyIdSuper(e.target.value)
  }

  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  function handleBlur() {
    if (isPhone) {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    } else {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    }
  }

  const handleEmailPhone = (e) => {
    // console.log(e.target.value);
    setIsEmailPhoneVal(false);
    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);

  };

  const handleDropdownValue = (e) => {
    // setCodeValue(e.target.value);
    setCodeValue(e);

  };

  return (
    <>
      {/* <!-- Modal --> */}
      <Modal
        className="fade"
        show={addUserTrigger}
        // onHide={handleCloseAddUser}
        centered
      >
        {/* <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title> {role === 3 ? btnAddUser : "Add team member"}</Modal.Title>
          <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={() => handleCloseAddUser()}
          ></Button>

        </Modal.Header> */}

        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">

              <div className='mx-0 row'>
                <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                  <span onClick={() => handleCloseAddUser()} className='cursor-pointer'>
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className='mx-0 row mb-4 pb-2 '>
                <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                  <span>
                    {(permissionArray.includes("ASSIGN COMPANY")) ? btnAddUser : "Add team member"}
                  </span>
                </div>
              </div>


              <JoinAsField
                // labelName={txtSignUpAs}
                labelName={'Register as'}
                onChange={handleRole}
                defaultValue={roleUser}
              />

              {
                roleUser != 2 &&
                // role === 3 &&
                (permissionArray.includes("ASSIGN COMPANY")) &&
                <SelectStateCompanies
                  labelName={"Companies"}
                  options={companiesList}
                  onChange={handleCompaniesSelectValue}
                  defaultValue={companyIdSuper}
                />
              }

              {permissionArray.includes("ASSIGN COMPANY") &&
                <div className="row mx-0">
                  <div className="col-sm-6 pe-sm-2">
                    <InputField
                      labelName={lblFirstName}
                      placeholderName={lblFirstName}
                      onChange={handleFirstName}
                      onBlur={handleFirstNameBlurCheck}
                      errorOccured={isFirstNameError}
                      errorMeesage={validFirstName}
                      value={firstName}
                      isRequired={true}
                    />
                  </div>

                  <div className="col-sm-6 ps-sm-2">
                    <InputField
                      labelName={lblLastName}
                      placeholderName={lblLastName}
                      onChange={handleLastName}
                      onBlur={handleLastNameBlurCheck}
                      value={lastName}
                    />
                  </div>
                </div>
              }

              <div className="row mb-2">
                <EmailPhoneCombine
                  isEnteringNumber={isPhone}
                  setIsEnteringNumber={setIsPhone}
                  handleInputValue={handleEmailPhone}
                  handleChangeCode={handleDropdownValue}
                  errorOccured={isEmailPhoneVal}
                  inputValue={emailPhoneValue}
                  handleOnBlur={handleBlur}
                  defaultCodeValue={codeValue}
                  errorMessage={
                    // validEmail_OR_MobileNumberText
                    loginErrorMsg
                  }
                  isRequired={true}
                />
              </div>

              {/* <InputField
                labelName={lblEmail}
                placeholderName={"Enter email"}
                onChange={handleEmail}
                errorMeesage={validEmailText}
                errorOccured={isEmailError}
                onBlur={handleEmailBlurCheck}
                value={email}
              />

              <EmailPhoneCombine
                inputValue={phonenumber}
                handleInputValue={handlePhonenumber}
                errorOccured={isPhoneError}
                errorMessage={validMobileNumberText}
                handleChangeCode={handleCountryCode}
                handleOnBlur={() => { }}
                isEnteringNumber={true}
                defaultCodeValue={countryCode}
                label={txtMobileNumber}
              /> */}


              {/* <PhonenumberField
            handleInputValue={handlePhonenumber}
            errorOccured={isPhoneError}
            errorMeesage={"invalid phone number"}
            inputValue={phonenumber}
            handleChangeCode={handleCountryCode}
            handleOnBlur={handlePhonenumberBlurCheck}
          /> */}

              <div className="d-flex align-items-center justify-content-center">
                <PrimaryButton
                  onClick={handleSubmit}
                  buttonName={permissionArray.includes("ASSIGN COMPANY") ? btnAddUser?.toUpperCase() : `SEND INVITE`}
                  isLoading={loaderActive}
                  loadingMessage={permissionArray.includes("ASSIGN COMPANY") ? "ADDING" : "SENDING"}
                  style={{
                    width: '100%',
                    border: 'none',
                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                  }}
                />
              </div>
            </div>
          </div>



        </Modal.Body>
      </Modal>

      {handleToaster && <ResponceToaster toasterType={toasterType} message={resMessage} />}
    </>
  );
};

export default AddUserByAdmin;
